import { axiosRequest, type AxiosResult } from "@/lib/axios";

const API_BASE_URL = import.meta.env.VITE_SERVICE_CORE_URL;

export const formTagApi = {
	attach: (workspaceId: string, formId: string, tagId: string): Promise<AxiosResult<void>> => {
		return axiosRequest({
			method: "POST",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/tags/${tagId}`,
		});
	},

	detach: (workspaceId: string, formId: string, tagId: string): Promise<AxiosResult<void>> => {
		return axiosRequest({
			method: "DELETE",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/tags/${tagId}`,
		});
	},

	sync: (workspaceId: string, formId: string, tagIds: string[]): Promise<AxiosResult<void>> => {
		return axiosRequest({
			method: "PUT",
			url: `${API_BASE_URL}/${workspaceId}/forms/${formId}/tags`,
			data: { tag_ids: tagIds },
		});
	},
};
